import * as Yup from "yup";

export const filesValidator = Yup.array().of(Yup.object({ id: Yup.string(), filename: Yup.string() }));
